import React from 'react';
import Modules from '@/modules/index';
import classNames from 'classnames';
import { ApiBlockItemModel, ApiBlockGridItemModel } from '@/client';

const CMSModule = ({
  module,
  className,
  ...props
}: {
  module: ApiBlockItemModel | ApiBlockGridItemModel;
  className?: string;
  [key: string]: any;
}) => {
  let moduleName = module?.content?.contentType;
  if (moduleName) {
    moduleName = String(moduleName).charAt(0).toUpperCase() + String(moduleName).slice(1);
    return moduleName && typeof Modules[moduleName] !== 'undefined' ? (
      React.createElement(Modules[moduleName], {
        id: module?.content?.id,
        data: module?.content?.properties,
        moduleName,
        ...props,
      })
    ) : (
      <div className={classNames('bg-white text-black', className)}>
        The Module <b>{moduleName}</b> has not been created yet.
      </div>
    );
  }
};

export default CMSModule;
